import { createContext, useContext } from 'react';

export const ActiveDragContext = createContext(null);
export const useActiveDrag = () => useContext(ActiveDragContext);
